<script>
export default {
  name: 'dingTalk',
  created () {
    const { code } = this.$route.query
    window.parent.postMessage({ code }, location.origin)
  }
}
</script>

<template>
<div></div>
</template>

<style scoped lang="scss">

</style>
